import React from 'react';
import styles from './styles.module.scss';

export interface ToggleSwitchProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Required when the switch has no associated <label>. */
  ariaLabel?: string;
  testId?: string;
  className?: string;
}

/**
 * On/off switch built on a native checkbox (`role="switch"`), so it keeps
 * keyboard focus, form semantics and label association.
 */
export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  onChange,
  disabled,
  ariaLabel,
  testId,
  className,
}) => (
  <span className={`${styles.root}${className ? ` ${className}` : ''}`}>
    <input
      id={id}
      type="checkbox"
      role="switch"
      className={styles.input}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      aria-checked={checked}
      aria-label={ariaLabel}
      data-testid={testId}
    />
    <span className={styles.track} aria-hidden="true">
      <span className={styles.knob} />
    </span>
  </span>
);

export default ToggleSwitch;
